export const baseURL = process.env.REACT_APP_BASE_URL;
export const secretKey = process.env.REACT_APP_SECRET_KEY;

export const agoraId = process.env.REACT_APP_AGORA_ID;

// Subdomain routing - editable via .env
// Required: checked by scripts/prepare-env.js before every build.
export const subdomainAdmin = process.env.REACT_APP_SUBDOMAIN_ADMIN;
export const subdomainContentCreator = process.env.REACT_APP_SUBDOMAIN_CONTENT_CREATOR;
export const termsUrl = process.env.REACT_APP_TERMS_URL;
